import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { getScenariosForApprovalTable, urls } from "./scenarioApprovalUtils";
import { saveAs } from "file-saver";
const initialState = {
  isLoading: false,
  rejectScenarioModalOpen: false,

  searchText: "",
  isSuccess: false,
  isSuccess_Info: false,
  isFailed: false,
  isFailed_Info: "",
  isError: false,
  isError_Info: "",
  message: "",
  severity: "",
  messageOpen: false,
  countries: [],
  selectedCountry: "",
  selectedCountryID: "",

  navigatedCountryID: "",

  scenarioStatusList: [],
  selectedScenarioStatus: "",

  periods: [],
  selectedPeriod: "",

  scenariosForApproval: null,
  scenariosForApprovalTable: null,

  scenarioDetails: null,

  selectedRows: [],

  rejectMultiModalOpen: false,
  rejectSelectedComment: "",
  files: [],
  filepath: [],
};

export const getUserCountries = createAsyncThunk(
  "scenarioApproval/getUserCountries",
  async (obj, thunkAPI) => {
    try {
      const data = JSON.parse(localStorage.getItem("data"));
      const token = data.token;
      const url = urls.userCountries + `userid=${data.userID}`;

      const response = await fetch(url, {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
          Accept: "application/json",
        },
      });
      const jsonData = response.json();
      return jsonData;
    } catch (error) {
      console.error("quota/getUserCountries", error);
    }
  }
);
export const Upload = createAsyncThunk(
  "approval/Upload",
  async (obj, { dispatch, getState }) => {
    const { files } = getState().scenarioApproval;
    const data = JSON.parse(localStorage.getItem("data"));
    const token = data.token;
    const formData = new FormData();
    for (var i = 0; i < files.length; i++) {
      formData.append("files", files[i], files[i].name);
    }
    const url = urls.Upload;
    try {
      const response = await fetch(url, {
        method: "POST",
        headers: {
          Authorization: `Bearer ${token}`,
          Accept: "application/json",
          "Content-Disposition": "multipart/form-data",
        },
        body: formData,
      });
      const jsonData = await response.json();
      return jsonData;
    } catch (error) {
      console.error("Error: ", error);
    }
  }
);

export const getScenarioStatus = createAsyncThunk(
  "scenarioApproval/getScenarioStatus",
  async (obj, thunkAPI) => {
    try {
      const data = JSON.parse(localStorage.getItem("data"));
      const token = data.token;
      const url = urls.scenarioStatus;

      const response = await fetch(url, {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
          Accept: "application/json",
        },
      });
      const jsonData = response.json();
      return jsonData;
    } catch (error) {
      console.error("scenarioApproval/getScenarioStatus", error);
    }
  }
);

export const getPeriods = createAsyncThunk(
  "scenarioApproval/getPeriods",
  async (obj, thunkAPI) => {
    try {
      const data = JSON.parse(localStorage.getItem("data"));
      const token = data.token;
      const url = urls.periods;

      const response = await fetch(url, {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
          Accept: "application/json",
        },
      });
      const jsonData = response.json();
      return jsonData;
    } catch (error) {
      console.error("scenarioApproval/getPeriods", error);
    }
  }
);

export const getScenariosForApproval = createAsyncThunk(
  "scenarioApproval/getScenariosForApproval",
  async (obj, thunkAPI) => {
    try {
      const data = JSON.parse(localStorage.getItem("data"));
      const token = data.token;
      const url = urls.scenariosForApproval;

      const response = await fetch(url, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
          Accept: "application/json",
        },
        body: JSON.stringify(obj),
      });
      const jsonData = response.json();
      return jsonData;
    } catch (error) {
      console.error("scenarioApproval/getScenariosForApproval", error);
    }
  }
);

export const getScenarioDetails = createAsyncThunk(
  "scenarioApproval/getScenarioDetails",
  async (obj, thunkAPI) => {
    try {
      const data = JSON.parse(localStorage.getItem("data"));
      const token = data.token;
      const url = urls.scenarioDetails + `scenarioId=${obj.scenarioId}`;

      const response = await fetch(url, {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
          Accept: "application/json",
        },
      });
      const jsonData = response.json();
      return jsonData;
    } catch (error) {
      console.error("scenarioApproval/getScenarioDetails", error);
    }
  }
);

//post call
export const approveScenario = createAsyncThunk(
  "scenarioApproval/approveScenario",
  async (formData, thunkAPI) => {
    try {
      const data = JSON.parse(localStorage.getItem("data"));
      const token = data.token;
      const url = urls.approveScenario;

      const response = await fetch(url, {
        method: "POST",
        headers: {
          "Content-Disposition": "multipart/form-data",
          Authorization: `Bearer ${token}`,
          Accept: "application/json",
        },
        body: formData,
      });
      const jsonData = response.json();
      return jsonData;
    } catch (error) {
      console.error("scenarioApproval/approveScenario", error);
    }
  }
);

//post call
export const rejectScenario = createAsyncThunk(
  "scenarioApproval/rejectScenario",
  async (formData, thunkAPI) => {
    try {
      const data = JSON.parse(localStorage.getItem("data"));
      const token = data.token;
      const url = urls.rejectScenario;

      const response = await fetch(url, {
        method: "POST",
        headers: {
          "Content-Disposition": "multipart/form-data",
          Authorization: `Bearer ${token}`,
          Accept: "application/json",
        },
        body: formData,
      });
      const jsonData = response.json();
      return jsonData;
    } catch (error) {
      console.error("scenarioApproval/rejectScenario", error);
    }
  }
);

//post call
export const approveMultiple = createAsyncThunk(
  "scenarioApproval/approveMultiple",
  async (obj, thunkAPI) => {
    try {
      const data = JSON.parse(localStorage.getItem("data"));
      const token = data.token;
      const url = urls.approveMultile;

      const response = await fetch(url, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
          Accept: "application/json",
        },
        body: JSON.stringify(obj),
      });
      const jsonData = response.json();
      return jsonData;
    } catch (error) {
      console.error("scenarioApproval/approveMultiple", error);
    }
  }
);

//post call
export const rejectMultiple = createAsyncThunk(
  "scenarioApproval/rejectMultiple",
  async (obj, { dispatch, getState }) => {
    try {
      const { filepath } = getState().scenarioApproval;
      if (filepath !== undefined && filepath != null && filepath.length > 0) {
        for (let i = 0; i < obj.length; i++) {
          obj[i].scenarioFiles = filepath;
        }
      }
      const data = JSON.parse(localStorage.getItem("data"));
      const token = data.token;
      const url = urls.rejectMultile;

      const response = await fetch(url, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
          Accept: "application/json",
        },
        body: JSON.stringify(obj),
      });
      const jsonData = response.json();
      return jsonData;
    } catch (error) {
      console.error("scenarioApproval/rejectMultiple", error);
    }
  }
);
export const DownloadFile = createAsyncThunk(
  "define/downloadfile",
  async (filepath, thunkAPI) => {
    const data = JSON.parse(localStorage.getItem("data"));
    const token = data.token;
    const url = urls.Downloadfile + `fileName=${filepath}`;
    try {
      const response = await fetch(url, {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
          Accept: "application/json",
        },
      });
      const res = await response.blob();
      const fileName = filepath;
      saveAs(res, fileName);
      return res;
    } catch (error) {
      console.error("Error: ", error);
    }
  }
);

export const scenarioApprovalSlice = createSlice({
  name: "scenarioApproval",
  initialState,
  reducers: {
    setState: {
      prepare(name, value) {
        return {
          payload: { name, value },
        };
      },
      reducer(state, action) {
        const { name, value } = action.payload;
        state[name] = value;
      },
    },
    reset(state, { payload }) {
      if (payload === "refresh") {
        state.isLoading = false;
        state.rejectScenarioModalOpen = false;
        state.searchText = "";
        state.selectedCountry = "";
        state.selectedCountryID = "";
        state.selectedScenarioStatus = "";
        state.selectedPeriod = "";
        state.scenariosForApproval = null;
        state.scenariosForApprovalTable = null;
        state.scenarioDetails = null;
        state.selectedRows = [];
        state.rejectMultiModalOpen = false;
        state.rejectSelectedComment = "";
      }
    },
    clearStatus(state, { payload }) {
      state.isSuccess = false;
      state.isSuccess_Info = false;
      state.isFailed = false;
      state.isFailed_Info = "";
      state.isError = false;
      state.isError_Info = "";
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(getUserCountries.pending, (state, action) => {
        state.isLoading = true;
      })
      .addCase(getUserCountries.fulfilled, (state, action) => {
        state.countries = action.payload;
        state.isLoading = false;
      })
      .addCase(getUserCountries.rejected, (state, action) => {
        console.error("quota/getUserCountries", action.error.message);
        state.isLoading = false;
      })

      .addCase(getScenarioStatus.pending, (state, action) => {
        state.isLoading = true;
      })
      .addCase(getScenarioStatus.fulfilled, (state, action) => {
        state.scenarioStatusList = action.payload;
        state.isLoading = false;
      })
      .addCase(getScenarioStatus.rejected, (state, action) => {
        console.error(
          "scenarioApproval/getScenarioStatus",
          action.error.message
        );
        state.isLoading = false;
      })

      .addCase(getPeriods.pending, (state, action) => {
        state.isLoading = true;
      })
      .addCase(getPeriods.fulfilled, (state, action) => {
        state.periods = action.payload;
        state.isLoading = false;
      })
      .addCase(getPeriods.rejected, (state, action) => {
        console.error("scenarioApproval/getPeriods", action.error.message);
        state.isLoading = false;
      })

      .addCase(getScenariosForApproval.pending, (state, action) => {
        state.isLoading = true;
      })
      .addCase(getScenariosForApproval.fulfilled, (state, action) => {
        state.scenariosForApproval = action.payload;
        if(action.payload.length === 0){
          state.isFailed = true;
          state.isFailed_Info = "No records found.";
        }
        state.scenariosForApprovalTable = getScenariosForApprovalTable(
          action.payload
        );
        state.isLoading = false;
      })
      .addCase(getScenariosForApproval.rejected, (state, action) => {
        console.error(
          "scenarioApproval/getScenariosForApproval",
          action.error.message
        );
        state.isLoading = false;
      })

      .addCase(getScenarioDetails.pending, (state, action) => {
        state.isLoading = true;
      })
      .addCase(getScenarioDetails.fulfilled, (state, action) => {
        state.scenarioDetails = action.payload;
        state.isLoading = false;
      })
      .addCase(getScenarioDetails.rejected, (state, action) => {
        console.error(
          "scenarioApproval/getScenarioDetails",
          action.error.message
        );
        state.isLoading = false;
      })

      .addCase(approveScenario.pending, (state, action) => {
        state.isLoading = true;
      })
      .addCase(approveScenario.fulfilled, (state, action) => {
        //state.isLoading = false;
        if (action.payload === true) {
          state.isSuccess = true;
          state.isSuccess_Info = "Scenario Approved successfully.";
        } else {
          state.isFailed = false;
          state.isFailed_Info = "Scenario Approval failed.";
        }
      })
      .addCase(approveScenario.rejected, (state, action) => {
        console.error("scenarioApproval/approveScenario", action.error.message);
        state.isLoading = false;
      })

      .addCase(rejectScenario.pending, (state, action) => {
        state.isLoading = true;
      })
      .addCase(rejectScenario.fulfilled, (state, action) => {
        //state.isLoading = false;
        if (action.payload === true) {
          state.isSuccess = true;
          state.isSuccess_Info = "Scenario Rejected successfully.";
        } else {
          state.isFailed = false;
          state.isFailed_Info = "Scenario Reject failed.";
        }
      })
      .addCase(rejectScenario.rejected, (state, action) => {
        console.error("scenarioApproval/rejectScenario", action.error.message);
        state.isLoading = false;
      })

      .addCase(approveMultiple.pending, (state, action) => {
        state.isLoading = true;
      })
      .addCase(approveMultiple.fulfilled, (state, action) => {
        //state.isLoading = false;
        if (action.payload === true) {
          state.isSuccess = true;
          state.isSuccess_Info =
            "Selected scenarios are approved successfully.";
        } else {
          state.isFailed = false;
          state.isFailed_Info = "Selected scenarios are failed to approve.";
        }
      })
      .addCase(approveMultiple.rejected, (state, action) => {
        console.error("scenarioApproval/approveMultiple", action.error.message);
        state.isLoading = false;
      })

      .addCase(rejectMultiple.pending, (state, action) => {
        state.isLoading = true;
      })
      .addCase(rejectMultiple.fulfilled, (state, action) => {
        //state.isLoading = false;
        if (action.payload === true) {
          state.isSuccess = true;
          state.isSuccess_Info =
            "Selected scenarios are rejected successfully.";
        } else {
          state.isFailed = false;
          state.isFailed_Info = "Selected scenarios are failed to reject.";
        }
      })
      .addCase(rejectMultiple.rejected, (state, action) => {
        console.error("scenarioApproval/rejectMultiple", action.error.message);
        state.isLoading = false;
      })
      .addCase(Upload.pending, (state, action) => {
        state.isLoading = true;
      })
      .addCase(Upload.fulfilled, (state, { payload }) => {
        state.isLoading = false;
        state.filepath = payload;
        state.files = [];
      })
      .addCase(Upload.rejected, (state, action) => {
        state.isLoading = false;
      })
      .addCase(DownloadFile.pending, (state, action) => {
        state.isLoading = true;
      })
      .addCase(DownloadFile.fulfilled, (state, action) => {
        state.isLoading = false;
      })
      .addCase(DownloadFile.rejected, (state, action) => {
        console.error("quota/DownloadFile", action.error.message);
        state.isLoading = false;
      });
  },
});

export const { setState, reset, clearStatus } = scenarioApprovalSlice.actions;
export default scenarioApprovalSlice.reducer;
